var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length)?_c('mention-box',{attrs:{"items":_vm.items},on:{"mention-select":_vm.handleMentionClick},scopedSlots:_vm._u([{key:"default",fn:function({ item }){return [_c('strong',[_vm._v(_vm._s(item.label))]),_vm._v(" - "+_vm._s(item.description)+"\n  ")]}}],null,false,2772235510)}):_vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }